(function() { module.exports = this["wp"]["element"]; }());


//////////////////
// WEBPACK FOOTER
// external {"this":["wp","element"]}
// module id = 3
// module chunks = 0